// var locData = []
// var worker = null


export function getSettings (country = 'Malaysia') {
  var countries = require('@/components/config/settings.json')
  var settings = {}

  for (let i = 0; i < countries.settings.length; i++) {

    if (countries.settings[i].country.toLowerCase() === country.toLowerCase()) {
      settings = countries.settings[i]
    }
  }

  return settings
}


export function getRegions (country = 'Malaysia') {
  var regions = require('@/components/config/locality/' + country.toLowerCase() + '.json')
  return regions
}



export function getSubset (data, key1, key2 = null) {

  for (var i = 0; i < data.length; i++) {

    if (data[i].value === key1) {

      if (!key2) {
        return data[i].children
      } else {

        for (var i2 = 0; i2 < data[i].children.length; i2++) {

          if (data[i].children[i2].value === key2) {
            return data[i].children[i2].children
          }
        } // for

      }
    }
  } // for

  return []
}
